// app/javascript/controllers/quote_modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "panel"]

  connect() {
    this._openHandler  = () => this.open()
    this._closeHandler = () => this.close()
    document.addEventListener("oe2:quote:open", this._openHandler)
    document.addEventListener("oe2:quote:close", this._closeHandler)

    if (this.hasContainerTarget) this.containerTarget.classList.add("hidden")
  }

  disconnect() {
    document.removeEventListener("oe2:quote:open", this._openHandler)
    document.removeEventListener("oe2:quote:close", this._closeHandler)
  }

  // Fired by turbo:frame-load
  open() {
    if (!this.hasContainerTarget) return
    this.containerTarget.classList.remove("hidden")
    document.documentElement.classList.add("overflow-hidden")
    this.panelTarget?.focus()
  }

  close() {
    if (!this.hasContainerTarget) return
    this.containerTarget.classList.add("hidden")
    document.documentElement.classList.remove("overflow-hidden")
    // Clear frame so future clicks retrigger turbo:frame-load
    this.element.innerHTML = ""
  }

  backdropClose(event) {
    if (event.target === this.containerTarget) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
